(() => {
  const initialize = scope => {
    const forms = scope.matches?.('[data-collection-sort]') ? [scope] : scope.querySelectorAll('[data-collection-sort]');
    forms.forEach(form => {
      if (form.dataset.sortReady) return;
      form.dataset.sortReady = 'true';
      form.addEventListener('submit', event => {
        const select = form.querySelector('[name="sort_by"]');
        if (!select || ![...select.options].some(option => option.value === select.value)) return;
        event.preventDefault();
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
